import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingInlineEnd: 56,
      paddingInlineStart: 56,

      '@media (max-width: 1180px)': {
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
      },
    },
    panels: {
      '@media (max-width: 1600px)': {
        display: 'block',
        overflowX: 'scroll',
        whiteSpace: 'nowrap',
      },
    },
    topPanels: {
      maxWidth: '20%',
      flexBasis: '20%',
      minWidth: 220,

      '@media (max-width: 1600px)': {
        width: 240,
        maxWidth: 240,
        flexBasis: 'unset',
        display: 'inline-block',
        marginRight: 10,
      },
    },
    topPanelRepresentative: {
      maxWidth: '25%',
      flexBasis: '25%',

      '@media (max-width: 1600px)': {
        width: 240,
        maxWidth: 240,
        flexBasis: 'unset',
        display: 'inline-block',
        marginRight: 10,
      },
    },
    filterContainer: {
      paddingBottom: 5,
      justifyContent: 'space-between',
    },
    quickReportsPanel: {
      display: 'block',
      whiteSpace: 'nowrap',
      '-ms-overflow-style': 'none',
      scrollbarWidth: 'none',
      overflowX: 'auto',
      width: 'calc(100% - 161px)',

      '@media (max-width: 960px)': {
        width: '100%',
        '-ms-overflow-style': 'auto',
        scrollbarWidth: 'auto',
      },
    },
    quickReports: {
      minWidth: 220,
      flexBasis: 'unset',
      display: 'inline-block',
    },
    currencyFormControlTitle: {
      color: '#030C2180',
      display: 'block',
      fontWeight: 400,
      fontSize: 12,
      textAlign: 'start',
      margin: 'auto',
    },
    container: {
      justifyContent: 'center',
      paddingTop: 10,
      paddingBottom: 10,
      width: '100%',
    },
    desktopContainer: {
      '@media (max-width: 1180px)': {
        display: 'none',
      },
    },
    mobileContainer: {
      '@media (min-width: 1181px)': {
        display: 'none',
      },
    },
    dialog: {
      width: 343,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',
    },
    selectContainer: {
      '& .MuiInputBase-root': {
        width: '100%',
        height: 56,
        borderRadius: 8,
        backgroundColor: variables.greyLight,
        border: 0,
        textAlign: 'start',
        padding: 16,
        color: variables.richBlack,

        '&::before': {
          display: 'none',
        },

        '&::after': {
          display: 'none',
        },

        '&:hover': {
          border: 0,
        },

        '&:focus': {
          border: '1px solid black',
          borderRadius: 8,
        },

        '& fieldset': {
          border: 'none',
        },

        '& .MuiSelect-root:focus': {
          border: 'none',
          backgroundColor: 'unset',
        },

        '& .MuiInputAdornment-positionStart': {
          marginLeft: 0,
          marginRight: 10,
        },

        '& .MuiSvgIcon-root': {
          marginRight: 8,
        },
      },
    },
    leftRightBtn: {
      width: 58,
      height: 140,
      borderRadius: 16,
      padding: '56px 15px',
      backgroundColor: '#FAFAFA',

      '@media (max-width: 960px)': {
        display: 'none',
      },
    },
    rtlIcon: {
      '& .MuiSvgIcon-root': {
        right: 'unset',
        left: '7px',
      },
    },
  }),
);
